module.exports = __webpack_public_path__ + "img/del.f72b4207.webp";